// Use word joiner for non-breaking hyphen because iOS bug causes regular non-breaking hyphens to render as underscores.
var wordjoiner = "\u2060";
export var nbh = "".concat(wordjoiner, "-").concat(wordjoiner); // non breaking hyphen;

export var nbsp = "\xA0"; // non breaking space;